import { IHandBookSegment } from "../model/types";
import { IIdAndName } from "types/idAndName";

const findSegment = (segments: IHandBookSegment[], matcher: (s: IHandBookSegment | IIdAndName) => boolean) => {
  let parentSegment: IHandBookSegment | null = null;
  let segment: IIdAndName | null = null;
  for (let i = 0; i < segments.length; i++) {
    const parentCandidate = segments[i];
    if (matcher(parentCandidate)) {
      parentSegment = parentCandidate;
    }
    for (let j = 0; j < parentCandidate.children.length; j++) {
      const segmentCandidate = parentCandidate.children[j];
      if (matcher(segmentCandidate)) {
        parentSegment = parentCandidate;
        segment = segmentCandidate;
        break;
      }
    }
    if (segment) {
      break;
    }
  }
  return { segment, parentSegment };
};

export const findSegmentsById = (segments: IHandBookSegment[], segment_id: number) =>
  findSegment(segments, (s) => s.id === segment_id);
export const findSegmentsByName = (segments: IHandBookSegment[], segment_name: string) =>
  findSegment(segments, (s) => s.name === segment_name);
